"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgClientImpl = exports.MsgMintResponse = exports.MsgMint = exports.MsgBurnResponse = exports.MsgBurn = exports.MsgTransferResponse = exports.MsgTransfer = exports.protobufPackage = void 0;
var minimal_1 = require("protobufjs/minimal");
exports.protobufPackage = "firmachain.firmachain.nft";
var baseMsgTransfer = { owner: "", nftId: 0, toAddress: "" };
exports.MsgTransfer = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.owner !== "") {
            writer.uint32(10).string(message.owner);
        }
        if (message.nftId !== 0) {
            writer.uint32(16).uint64(message.nftId);
        }
        if (message.toAddress !== "") {
            writer.uint32(26).string(message.toAddress);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgTransfer);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.owner = reader.string();
                    break;
                case 2:
                    message.nftId = longToNumber(reader.uint64());
                    break;
                case 3:
                    message.toAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgTransfer);
        if (object.owner !== undefined && object.owner !== null) {
            message.owner = String(object.owner);
        }
        else {
            message.owner = "";
        }
        if (object.nftId !== undefined && object.nftId !== null) {
            message.nftId = Number(object.nftId);
        }
        else {
            message.nftId = 0;
        }
        if (object.toAddress !== undefined && object.toAddress !== null) {
            message.toAddress = String(object.toAddress);
        }
        else {
            message.toAddress = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.owner !== undefined && (obj.owner = message.owner);
        message.nftId !== undefined && (obj.nftId = message.nftId);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgTransfer);
        if (object.owner !== undefined && object.owner !== null) {
            message.owner = object.owner;
        }
        else {
            message.owner = "";
        }
        if (object.nftId !== undefined && object.nftId !== null) {
            message.nftId = object.nftId;
        }
        else {
            message.nftId = 0;
        }
        if (object.toAddress !== undefined && object.toAddress !== null) {
            message.toAddress = object.toAddress;
        }
        else {
            message.toAddress = "";
        }
        return message;
    },
};
var baseMsgTransferResponse = {};
exports.MsgTransferResponse = {
    encode: function (_, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgTransferResponse);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (_) {
        var message = __assign({}, baseMsgTransferResponse);
        return message;
    },
    toJSON: function (_) {
        var obj = {};
        return obj;
    },
    fromPartial: function (_) {
        var message = __assign({}, baseMsgTransferResponse);
        return message;
    },
};
var baseMsgBurn = { owner: "", nftId: 0 };
exports.MsgBurn = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.owner !== "") {
            writer.uint32(10).string(message.owner);
        }
        if (message.nftId !== 0) {
            writer.uint32(16).uint64(message.nftId);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgBurn);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.owner = reader.string();
                    break;
                case 2:
                    message.nftId = longToNumber(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgBurn);
        if (object.owner !== undefined && object.owner !== null) {
            message.owner = String(object.owner);
        }
        else {
            message.owner = "";
        }
        if (object.nftId !== undefined && object.nftId !== null) {
            message.nftId = Number(object.nftId);
        }
        else {
            message.nftId = 0;
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.owner !== undefined && (obj.owner = message.owner);
        message.nftId !== undefined && (obj.nftId = message.nftId);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgBurn);
        if (object.owner !== undefined && object.owner !== null) {
            message.owner = object.owner;
        }
        else {
            message.owner = "";
        }
        if (object.nftId !== undefined && object.nftId !== null) {
            message.nftId = object.nftId;
        }
        else {
            message.nftId = 0;
        }
        return message;
    },
};
var baseMsgBurnResponse = { result: false };
exports.MsgBurnResponse = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.result === true) {
            writer.uint32(8).bool(message.result);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgBurnResponse);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.result = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgBurnResponse);
        if (object.result !== undefined && object.result !== null) {
            message.result = Boolean(object.result);
        }
        else {
            message.result = false;
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.result !== undefined && (obj.result = message.result);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgBurnResponse);
        if (object.result !== undefined && object.result !== null) {
            message.result = object.result;
        }
        else {
            message.result = false;
        }
        return message;
    },
};
var baseMsgMint = { owner: "", tokenURI: "" };
exports.MsgMint = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.owner !== "") {
            writer.uint32(10).string(message.owner);
        }
        if (message.tokenURI !== "") {
            writer.uint32(18).string(message.tokenURI);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgMint);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.owner = reader.string();
                    break;
                case 2:
                    message.tokenURI = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgMint);
        if (object.owner !== undefined && object.owner !== null) {
            message.owner = String(object.owner);
        }
        else {
            message.owner = "";
        }
        if (object.tokenURI !== undefined && object.tokenURI !== null) {
            message.tokenURI = String(object.tokenURI);
        }
        else {
            message.tokenURI = "";
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.owner !== undefined && (obj.owner = message.owner);
        message.tokenURI !== undefined && (obj.tokenURI = message.tokenURI);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgMint);
        if (object.owner !== undefined && object.owner !== null) {
            message.owner = object.owner;
        }
        else {
            message.owner = "";
        }
        if (object.tokenURI !== undefined && object.tokenURI !== null) {
            message.tokenURI = object.tokenURI;
        }
        else {
            message.tokenURI = "";
        }
        return message;
    },
};
var baseMsgMintResponse = { nftId: 0 };
exports.MsgMintResponse = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = minimal_1.Writer.create(); }
        if (message.nftId !== 0) {
            writer.uint32(8).uint64(message.nftId);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = __assign({}, baseMsgMintResponse);
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nftId = longToNumber(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON: function (object) {
        var message = __assign({}, baseMsgMintResponse);
        if (object.nftId !== undefined && object.nftId !== null) {
            message.nftId = Number(object.nftId);
        }
        else {
            message.nftId = 0;
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.nftId !== undefined && (obj.nftId = message.nftId);
        return obj;
    },
    fromPartial: function (object) {
        var message = __assign({}, baseMsgMintResponse);
        if (object.nftId !== undefined && object.nftId !== null) {
            message.nftId = object.nftId;
        }
        else {
            message.nftId = 0;
        }
        return message;
    },
};
var MsgClientImpl = /** @class */ (function () {
    function MsgClientImpl(rpc) {
        this.rpc = rpc;
    }
    MsgClientImpl.prototype.Transfer = function (request) {
        var data = exports.MsgTransfer.encode(request).finish();
        var promise = this.rpc.request("firmachain.firmachain.nft.Msg", "Transfer", data);
        return promise.then(function (data) { return exports.MsgTransferResponse.decode(new minimal_1.Reader(data)); });
    };
    MsgClientImpl.prototype.Burn = function (request) {
        var data = exports.MsgBurn.encode(request).finish();
        var promise = this.rpc.request("firmachain.firmachain.nft.Msg", "Burn", data);
        return promise.then(function (data) { return exports.MsgBurnResponse.decode(new minimal_1.Reader(data)); });
    };
    MsgClientImpl.prototype.Mint = function (request) {
        var data = exports.MsgMint.encode(request).finish();
        var promise = this.rpc.request("firmachain.firmachain.nft.Msg", "Mint", data);
        return promise.then(function (data) { return exports.MsgMintResponse.decode(new minimal_1.Reader(data)); });
    };
    return MsgClientImpl;
}());
exports.MsgClientImpl = MsgClientImpl;
var globalThis = (function () {
    if (typeof globalThis !== "undefined")
        return globalThis;
    if (typeof self !== "undefined")
        return self;
    if (typeof window !== "undefined")
        return window;
    if (typeof global !== "undefined")
        return global;
    throw "Unable to locate global object";
})();
function longToNumber(long) {
    if (long.gt(Number.MAX_SAFE_INTEGER)) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    return long.toNumber();
}
